/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Params } from '@angular/router';
import {
  LabelValue,
  MainFilterItem,
  MAIN_FILTER_ITEMS,
  DOMAIN_FILTERS
} from './DOMAIN_DETAILS_CONFIG';
import { DomainService } from '../../../../services/domain-service';
import { UtilFunctions } from '../../util-functions';
import { DetailsPageComponent } from '../details-page/details-page.component';
import { DOMAIN_INSIGHTS_PERMISSION } from '../../../../models/User';
import { AuthState } from 'app/services/auth.service';
import { SideNavItem } from 'app/models/SideNavItem';
import { domainDetailsNavItems } from './side-navigation-items';
import { StructuredDomainData } from '../../../../services/page-meta.service';

export const TRACKING_ID = 'domain_details_link';
declare let jQuery: any;
declare let toastr: any;

export interface DomainFilter {
  appId?: string;
  region?: string;
  device?: string;
  month?: string;
  country?: string;
  queryParams?: any;
}

@Component({
  selector: 'app-new-insights-domain-details',
  templateUrl: './domain-details.component.html',
  styleUrls: [
    '../details-page/details-page.component.scss',
    '../details-page/details-page-common.scss',
    './domain-details.component.scss',
    '../details-page/details-page-responsive.component.scss'
  ]
})
export class DomainDetailsComponent extends DetailsPageComponent {
  loading = true;
  loadingData = false;

  region: string;
  country: string;
  device: string;
  month: string;
  mainFilterItems: Array<MainFilterItem>;
  prevMainFilterItems: Array<MainFilterItem>;
  document: any;
  showNoData: boolean;
  domainFilters = DOMAIN_FILTERS;
  domainFiltersIndex = 0;
  availableFilters = [];
  monthFilter: any;

  tempFilter: DomainFilter = {};

  adsTxtEnabled: boolean;
  loadingChangeLog: boolean;
  changeLogData: any;

  hideOverlap: boolean;
  showNoDataFound: boolean;

  selectedCountry: any;

  cachedSegmentEvent = {};

  @ViewChild('changelogModal') changelogModal;

  sideNavItems: SideNavItem[] = domainDetailsNavItems;

  constructor(
    private route: ActivatedRoute,
    private el: ElementRef,
    private _domainService: DomainService
  ) {
    super(route, el, DOMAIN_INSIGHTS_PERMISSION);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.document = this._el.nativeElement.ownerDocument;

    this.dataUpdateRequested = true;
    this.onNavigationEnd(null);
    this.trackingId = TRACKING_ID;
    this.type = 'domain';
    this.cachedSegmentEvent = {};
  }

  onAuthStateChange(evt: AuthState) {
    console.log('auth state changed');

    void this.searchDomain().then(() => {
      this.updateFollowingState();
    });
  }

  onNavigationEnd(evt: NavigationEnd) {
    console.log('nav state changed');

    super.onNavigationEnd(evt);

    if (this.dataUpdateRequested && !this.loadingData) {
      this.dataUpdateRequested = false;

      void this.getNumWatching(this.appId, 'domains');

      void this.searchDomain().then(() => {
        console.log('done fetching app');
        this.updateFollowingState();
        this.scrollToInitialSection();
      });
    }
  }

  onQueryParamsChange(params: Params) {
    console.log(
      `%c--- query params changed ---`,
      'color: blue; font-size: 15px'
    );

    this.month = this.getValidMonthParam(params['month'] as string);
    this.country = params['country'] || 'GLOBAL';

    this.requestDataUpdate();
  }

  onParamsChange(params: Params) {
    console.log(`%c--- params changed ---`, 'color: blue; font-size: 15px');
    this.appId = params['domain'];
    this.region = params['region'];
    this.device = this.getValidDeviceParam(params['device'] as string);

    this.mainFilterItems = JSON.parse(JSON.stringify(MAIN_FILTER_ITEMS));
    this.hideOverlap = this.userService.hasPermission('mrtUserOverlap');

    this.requestDataUpdate();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  onWatchlistUpdate(evt: any) {
    console.log('watching update evt', evt);

    if (
      evt.type === 'sync' ||
      (evt.follow.id === this.appId && evt.follow.type === 'domain')
    ) {
      void this.getNumWatching(this.appId, 'domains');

      void this.searchDomain(true).then(() => {
        console.log('done fetching domain from watchlist');

        this.updateFollowingState();
      });
    }
  }

  getAppName(): string {
    return `${this.appId}`;
  }

  getAppOS(): string {
    return 'domain';
  }

  getStructuredData(): StructuredDomainData {
    return {
      domain: `${this.appId}`
      //score: 'string',
    };
  }

  showChangelog() {
    if (!this.changelogModal) return;

    jQuery(this.changelogModal.nativeElement).modal({
      backdrop: false,
      keyboard: true,
      focus: true,
      show: true
    });
  }

  updateFollowingState(): boolean {
    const oldFollowing = this.isFollowing;
    this.isFollowing = super.updateFollowingState();
    this._domainService.setFollowing(this.isFollowing);
    console.log('UPDATING FOLLOW STATE', this.isFollowing, this.appId);
    // Research if new state for isFollowing
    if (oldFollowing !== this.isFollowing) {
      void this.searchDomain();
    }
    return this.isFollowing;
  }

  goToSection(anchor: string) {
    this.scrollToSection(anchor.substr(1));
  }

  async followApp() {
    if (!this.isProcessing) {
      if (this._authService.isAuthenticated()) {
        try {
          this._followService.updateProcessingFollow(true);
          await this._watchlistService.addFollow(
            this.appId,
            'domain',
            this.getAppOS()
          );
          await this.getNumWatching(this.appId, 'domains');
          this._eventBus.updateEyeNumFollowing.emit(true);
          this._followService.updateProcessingFollow(false);
          const props = {
            appUrl: window.location.href
          };
          this._tracking.eventTrack('domain_follow_success', props);
        } catch (error) {
          let message = 'Please try again next time.';

          if (error.status === 403) {
            const body = error.error;

            if (body.error === 'Quota Exceeded') {
              message = 'You have reached your limit of 10 follows.';
            }
          }

          const props = {
            appUrl: window.location.href,
            error: error
          };

          this._tracking.eventTrack('domain_follow_failed', props);
          toastr.error(message, 'Follow Failed!', { timeOut: 2000 });
          console.log('error: ', error);
          await this._watchlistService.removeFollow(
            this.appId,
            'domain',
            this.getAppOS()
          );
          this._followService.updateProcessingFollow(false);
        }
      } else {
        this._authService.signupWithFollow();
      }
    }
  }

  async unfollowApp() {
    if (!this.isProcessing) {
      try {
        this._followService.updateProcessingFollow(true);
        await this._watchlistService.removeFollow(
          this.appId,
          'domain',
          this.getAppOS()
        );
        await this.getNumWatching(this.appId, 'domains');
        this._eventBus.updateEyeNumFollowing.emit(true);
        this._followService.updateProcessingFollow(false);
      } catch (error) {
        const props = {
          appUrl: window.location.href,
          error: error
        };
        this._tracking.eventTrack('domain_unfollow_failed', props);
        toastr.error('Please try again next time.', 'UnFollow Failed!', {
          timeOut: 2000
        });
        console.log('error: ', error);
        this._followService.updateProcessingFollow(false);
      }
    }
  }

  updateMainFilterItems() {
    this.mainFilterItems.forEach(mainFilterItem => {
      const key = mainFilterItem.key;
      const paramValue = this._route.snapshot.params[key];
      if (paramValue) {
        mainFilterItem.options.forEach(option => {
          option.selected = option.value === paramValue;
          if (option.value === paramValue) {
            mainFilterItem.selected = option;
          }
        });
      }
    });
  }

  getMainFilter(key: string): MainFilterItem {
    return this.getMainFilterItem(this.mainFilterItems, key);
  }

  getMainFilterValue(key: string): string {
    return this.getMainFilterItemSelectedValue(this.mainFilterItems, key);
  }

  searchDomain(inBackground = false) {
    setTimeout(() => {
      this.updateMainFilterItems();
    }, 300);

    this.loadingData = !inBackground;

    if (this.userService.isFreemium()) {
      return this.getDomainData();
    } else {
      return this._domainService.getAvailableMonths('mrt').then(res => {
        if (
          res &&
          res['availableMonths'] &&
          res['availableMonths'].length > 0
        ) {
          const availableMonths = res['availableMonths'];
          this.monthFilter = this.getMainFilter('month');
          this.monthFilter.options = availableMonths;
          if (this.month && this.month.length > 0) {
            const foundMonth = this.monthFilter.options.filter(
              option => option.value === this.month
            );
            if (foundMonth && foundMonth.length > 0) {
              this.monthFilter.selected = foundMonth[0];
            }
          } else {
            this.monthFilter.selected = null;
          }
          this._domainService.setDevice(this.device);
          this._domainService.setRegion(this.region);
          this._domainService.setCountry(this.country);
          if (this.monthFilter.selected) {
            this._domainService.setMonth(this.monthFilter.selected.value);
          } else {
            this.monthFilter.selected = availableMonths[0];
            this._domainService.setMonth('');
          }
          return this.getDomainData();
        } else if (res && res['status'] === 403) {
          this._eventBus.showPopup();
        }
      });
    }
  }

  getDomainData() {
    return this._domainService
      .getAllData(this.appId)
      .then(res => {
        this.insightsData = res;
        const props = {
          domain: this.appId,
          region: this.region,
          country: this.country,
          device: this.device,
          month: this.month
        };
        setTimeout(() => {
          if (this.insightsData['overview']) {
            const lastUpdateString: string =
              this.insightsData['overview']['lastUpdatedDate'];
            if (lastUpdateString) {
              this.insightsData['overview']['lastUpdatedDateString'] =
                UtilFunctions.getDateString(lastUpdateString);
            }
          }
        }, 500);

        const key = window.location.href;
        if (!this.cachedSegmentEvent[key]) {
          this.cachedSegmentEvent[key] = true;
          this._tracking.eventTrack('domain_found', props);
        }
        this.initialize();
        this.updatePageMetadata();
      })
      .catch(error => {
        console.log('SERVER ERROR: ' + JSON.stringify(error));
        if (error.status == 403) {
          this._eventBus.showQuotaError('Insufficient quota.');
        }
      });
  }

  initialize() {
    this.loading = false;
    this.loadingData = false;
    if (this.insightsData.overview) {
      this.showNoData = false;
      setTimeout(() => {
        this.initDomainData();
        this.updateFollowingState();
        void this.getNumWatching(this.appId, 'domains');

        this.loadingChangeLog = true;

        void this._changelogService
          .getDomainChangelog(this.appId, this.region, this.device, this.month)
          .then(changeres => {
            this.loadingChangeLog = false;
            console.log('domain changelog res: ', changeres);
            if (changeres && changeres['numFound'] > 0) {
              this.changeLogData = changeres['docs'];
            }
          });
      }, 100);
    } else {
      this.showNoData = true;
      this.domainFiltersIndex = 0;
      this.availableFilters = [];
      this.findAvailableFilters(this.appId);
    }

    this._eventBus.showFeedback();
  }

  findAvailableFilters(domain: string) {
    if (!this.isFreemium) {
      this.getAvailableFilters(domain);
      return;
    }

    if (this.domainFiltersIndex < this.domainFilters.length) {
      const region = this.domainFilters[this.domainFiltersIndex].region;
      const regionText = this.domainFilters[this.domainFiltersIndex].regionText;
      const device = this.domainFilters[this.domainFiltersIndex].device;
      void this._domainService
        .getOverallData(domain, region, device, '')
        .then(res => {
          if (
            res != null &&
            res['overview'] != null &&
            res['overview']['pixalateGrade'] != null
          ) {
            let month = res['overview']['month'];
            month = month.replace('-', '');
            let monthLabel = null;
            const foundMonth = this.monthFilter.options.filter(
              option => option.value === month
            );
            if (foundMonth && foundMonth.length > 0) {
              monthLabel = foundMonth[0].label;
            }
            console.log('MONTH: ', monthLabel);
            this.availableFilters.push({
              domain: domain,
              region: region,
              regionText: regionText,
              device: device,
              month: month,
              monthLabel: monthLabel
            });
          }

          this.domainFiltersIndex++;
          this.findAvailableFilters(domain);
        });
    }
  }

  getAvailableFilters(domain: string) {
    this._domainService
      .getAvailableFilters(domain)
      .then(res => {
        if (res != null && res['availableFilters']) {
          const monthFilter = this.getMainFilterItem(
            this.mainFilterItems,
            'month'
          );
          this.availableFilters = res['availableFilters'].map((filter: any) => {
            let month: string = filter.month;
            let monthLabel = null;
            if (month) {
              month = month.replace('-', '');
              this.month = month;
              monthLabel = this.getMonthLabel(monthFilter.options, month);
            }
            return {
              ...filter,
              domain: domain,
              region: filter.region,
              regionText: filter.region,
              device: filter.deviceType,
              month: month,
              monthLabel: monthLabel
            };
          });
        }
      })
      .finally(() => {
        this.loading = false;
        this.loadingData = false;
      });
  }

  availableFilterClick(domainFilter: any) {
    this.showNoData = false;
    this.loading = false;
    this.loadingData = false;
    void this._router.navigate(
      [
        '/insight/domains',
        domainFilter.domain,
        domainFilter.region,
        domainFilter.device
      ],
      {
        queryParams: { month: this.month }
      }
    );
  }

  getAppScope() {
    this._domainService
      .getAppScopeData(
        this.appId,
        this.tempFilter.device,
        this.tempFilter.region,
        this.tempFilter.country,
        this.tempFilter.month
      )
      .then(res => {
        if (res['availableCountries']) {
          // Set Country Options if permission is enabled
          const countryFilter = this.getMainFilter('country');
          if (!this.isFreemium) {
            const countryOptions: Array<LabelValue> = [];
            const availableCountries: any[] = res['availableCountries'];
            if (availableCountries?.length > 0) {
              availableCountries.forEach(reg => {
                const countryCode: string = reg['countryCode'];
                const regionText =
                  countryCode === 'GLOBAL'
                    ? 'All Countries'
                    : reg['countryName'];
                let label = `<img class="dropdown-item-flag" src="//cdn.pixalate.com/icons/countries/flat/48/${countryCode}.png" alt="Flag Icon"/> `;
                label += regionText;
                countryOptions.push({
                  label: countryCode !== 'GLOBAL' ? label : regionText,
                  value: countryCode
                });
              });
            }

            countryFilter.options = countryOptions;
            const foundFilter = countryOptions.filter(
              filter => filter.value === this.tempFilter.country
            );
            if (foundFilter && foundFilter[0]) {
              countryFilter.selected = foundFilter[0];
            } else {
              // current country selected is not listed on the available countries, have to reload data
              countryFilter.selected = countryOptions[0]; // set the first option
            }
          } else {
            countryFilter.disabled = true;
          }

          this.initTooltips();
        }
      });
  }

  initDomainData() {
    let hasMismatchFilter = false;

    if (this.insightsData['overview']) {
      const section = this._route.snapshot.queryParams['section'];
      let monthData = this.insightsData['overview']['month'];
      if (this.userService.isFreemium()) {
        const monthFilter = this.getMainFilter('month');
        const monthArr: string[] = monthData.split('-');
        const currentMonthLabel =
          this.monthArray[Number.parseInt(monthArr[1]) - 1];
        const selectedMonthOption: LabelValue = {
          label: `${currentMonthLabel} ${monthArr[0]}`,
          value: `${monthArr[0]}${monthArr[1]}`
        };
        monthFilter.options = [];
        monthFilter.options.push(selectedMonthOption);
        monthFilter.selected = selectedMonthOption;
        monthFilter.disabled = true;
      } else {
        // Check if month loaded is the same if not update it on URL and dropdown
        const selectedMonth = this.getMainFilter('month').selected.value;
        monthData = monthData.replace('-', '');
        if (selectedMonth !== monthData) {
          const selectedOption = this.mainFilterItems
            .filter(mainFilter => mainFilter.key === 'month')[0]
            .options.filter(option => option.value === monthData)[0];
          if (selectedOption) {
            this.getMainFilter('month').selected = selectedOption;
            const queryParams = { month: monthData };
            if (section) {
              queryParams['section'] = section;
            }
            void this._router.navigate([], {
              queryParams: queryParams,
              replaceUrl: true
            });
          }
        }

        // Set Country Options if permission is enabled
        const countryFilter = this.getMainFilter('country');
        if (
          !this.isFreemium &&
          this.userService.domainInsightsCountryEnabled()
        ) {
          const countryOptions: Array<LabelValue> = [];
          if (
            this.insightsData['availableCountries'] &&
            this.insightsData['availableCountries'].length > 0
          ) {
            this.insightsData['availableCountries'].forEach(reg => {
              const regionText =
                reg['countryCode'] === 'GLOBAL'
                  ? 'All Countries'
                  : reg['countryName'];
              let label = `<img class="dropdown-item-flag" src="//cdn.pixalate.com/icons/countries/flat/48/${reg['countryCode']}.png" alt="Flag Icon"/> `;
              label += regionText;
              countryOptions.push({
                label: reg['countryCode'] !== 'GLOBAL' ? label : regionText,
                value: reg['countryCode']
              });
            });
          }

          countryFilter.options = countryOptions;
          const foundFilter = countryOptions.filter(
            filter => filter.value === this.country
          );
          if (foundFilter && foundFilter[0]) {
            countryFilter.selected = foundFilter[0];
          } else {
            // current country selected is not listed on the available countries, have to reload data
            countryFilter.selected = countryOptions[0]; // set the first option
            hasMismatchFilter = true;
          }
          this.selectedCountry = countryFilter.selected;
        } else {
          countryFilter.disabled = true;
        }
      }
    }

    if (hasMismatchFilter) {
      // Reload filters based on the current selection
      // this.selectMainFilter(null);
    }
  }

  dropdownClick($event, mainFilterItem: MainFilterItem, searchInputId: string) {
    if (mainFilterItem.options.length > 10) {
      setTimeout(() => {
        const input = jQuery(`#${searchInputId}`).get(0);
        if (input) {
          input.focus();
        }
        $event.preventDefault();
      }, 200);
    }
  }

  toggleDropdownOption(mainFilterItem: MainFilterItem, show: boolean) {
    mainFilterItem.show = show;
    this._mobileScrollService.toggleFilterOptions(show);
  }

  selectMainFilter(
    mainFilterItem: MainFilterItem,
    selectedOption: LabelValue,
    applyFilter = true
  ) {
    if (mainFilterItem && selectedOption) {
      mainFilterItem.selected = selectedOption;
      mainFilterItem.options.forEach(option => {
        option.selected = option.value === selectedOption.value;
      });
      if (applyFilter) {
        if (mainFilterItem.key === 'region') {
          this.region = mainFilterItem.selected.value;
        }
        if (mainFilterItem.key === 'device') {
          this.device = mainFilterItem.selected.value;
        }
        if (mainFilterItem.key === 'month') {
          this.month = mainFilterItem.selected.value;
        }
        if (mainFilterItem.key === 'country') {
          this.country = mainFilterItem.selected.value;
        }
      }
    }

    ///insight/domains/tumblr.com/US/mobile?section=%23domain-overview

    const region = this.getMainFilterValue('region');
    const device = this.getMainFilterValue('device');
    let country = 'GLOBAL';
    let month = this.getMainFilterValue('month');
    const queryParams = { month: month };

    const section = this._route.snapshot.queryParams['section'];
    if (section && section !== '') {
      queryParams['section'] = section;
    }

    if (!this.isFreemium) {
      if (mainFilterItem && mainFilterItem.key === 'region') {
        country = 'GLOBAL';
      } else {
        country = this.getMainFilterValue('country') || 'GLOBAL';
      }
      queryParams['country'] = country;
    }

    if (applyFilter) {
      void this._router.navigate(
        ['/insight/domains', this.appId, region, device],
        { queryParams: queryParams }
      );
    } else {
      this.tempFilter = {
        region,
        device,
        country,
        month,
        queryParams
      };

      this.getAppScope();
    }
  }

  showFilter() {
    this.prevMainFilterItems = JSON.parse(JSON.stringify(this.mainFilterItems));
    this.tempFilter = {
      region: this.region,
      device: this.device
    };
  }

  resetFilter() {
    this.mainFilterItems = JSON.parse(JSON.stringify(this.prevMainFilterItems));
  }

  applyFilter() {
    void this._router.navigate(
      [
        '/insight/domains',
        this.appId,
        this.tempFilter.region,
        this.tempFilter.device
      ],
      {
        queryParams: this.tempFilter.queryParams
      }
    );
    setTimeout(() => {
      void this.searchDomain();
    }, 100);
  }

  searchMainFilterItemOption(mainFilterItem: MainFilterItem, event: any) {
    const inputValue = jQuery(event.currentTarget).val();
    mainFilterItem.options.forEach(option => {
      if (option.value !== 'GLOBAL') {
        option.hidden =
          option.label.toLowerCase().indexOf(inputValue.toLowerCase()) < 0;
      }
    });
  }

  toAppDiscoveryClick(paramDetails: any) {
    jQuery('*[title]').tooltip('hide');
    const param: string = paramDetails.param;
    let paramValue = paramDetails.paramValue;
    if (
      paramDetails &&
      param &&
      paramValue &&
      paramValue !== 'N/A' &&
      this.userService.domainSearchEnabled()
    ) {
      if (paramValue === 'low') {
        paramValue = 'L';
      }
      if (paramValue === 'medium') {
        paramValue = 'M';
      }
      if (paramValue === 'high') {
        paramValue = 'H';
      }
      const queryParams = {};
      queryParams[param] = paramValue;
      setTimeout(() => {
        void this._router.navigate(
          ['/discovery/domains/list', this.device, this.region, 'F'],
          { queryParams: queryParams }
        );
      }, 100);
    }
  }
}
